define('views/modules/questionnaire/modal/questionnaire-modal',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // services
    'services/i18n',
    // events
    'services/events/questionnaire-events',
    // models
    'models/questionnaire/questionnaire',
    'models/questionnaire/response',
    // views
    'views/parts/modal/modal',
    'views/modules/questionnaire/modal/fill-questionnaire-content'
], function(
    // Libs
    _, Backbone, Mustache, U,
    // services
    i18n,
    // events
    QuestionnaireEvents,
    // models
    MQuestionnaire,
    MResponse,
    // views
    VModal,
    VFillQuestionnaireContent
) {

    var VQuestionnaireModal = VModal.extend({
        modal: function() {
            return {
                closeButton: false,
                buttons: {
                    confirm: {
                        label: i18n.t("Ok"),
                        callback: this.onConfirm
                    },
                }
            };
        },

        initialize: function(opt) {
            this.options = opt = opt || {};
            _.extend(this, opt);

            this.model = new MQuestionnaire();
            this.response = new MResponse();

            this.model.setId(this.questionnaire);

            this.fetchData(this);
        },

        fetchData: function(context) {
            this.when(
                this.model.fetch()
            ).then(function() {
                context.response.setQuestions(context.model.getQuestions());
                context.render();
            });
        },


        render: function() {
            this.view = {
                form: new VFillQuestionnaireContent({ questionnaire: this.model, model: this.response }),
            };

            this.$el.empty()
                .append(this.view.form.render().el);
            return this.renderModal();
        },


        onConfirm: function() {
            this.view.form.submit();
            QuestionnaireEvents.questionnaireSaved();
        }


    });

    return VQuestionnaireModal;

});

